import React from 'react';
import { VictoryChart, VictoryLine, VictoryAxis, VictoryGroup, VictoryLegend, VictoryContainer } from 'victory';
import { getMonthName, groupBy, getMonthTickValues } from './utils';
import * as Constants from './constants';

export const MarketComparisonChart = ({ rawData, manufacturerIds }) => {
    if (!rawData || !rawData.length) {
        return null;
    }

    const selectedManufacturerIds = new Set(manufacturerIds.map(id => id.toString()));
    const ungroupedData = rawData
        .map(d => {
            return {
                x: `${getMonthName(d.month)}-${d.year}`,
                y: d.rank,
                year: d.year,
                groupKey: `${d.manufacturerId}::${d.manufacturerName}`,
                manufacturerName: d.manufacturerName
            };
        });
    const dataByManufacturer = groupBy(ungroupedData, "groupKey");
    const totalManufacturers = Object.keys(dataByManufacturer).length;
    const selectedGroupKeys = Object.keys(dataByManufacturer)
        .filter(groupKey => selectedManufacturerIds.has(groupKey.split("::")[0]));
    const charts = selectedGroupKeys
        .map(groupKey => {
            return (<VictoryLine
                name={`marketComparisonLine:${groupKey}`}
                key={`marketComparisonLine:${groupKey}`}
                data={dataByManufacturer[groupKey]}
                style={{
                    labels: {
                        fontSize: Constants.DATA_LABEL_FONT_SIZE
                    }
                }}
            />);
        });
    const legendData = selectedGroupKeys.map(k => {
        const manufacturerName = k.split("::")[1];
        return { name: manufacturerName };
    });
    const xTickValues = getMonthTickValues(rawData);

    return (
        <div>
            <VictoryChart
                width={Constants.CHART_WIDTH}
                height={Constants.CHART_HEIGHT}
                maxDomain={{ y: totalManufacturers }}
                padding={{ top: 5, right: 16, bottom: 80, left: 70 }}
            >
                <VictoryAxis crossAxis
                    label="Month"
                    style={{
                        border: { stroke: "black" },
                        grid: {
                            stroke: "grey",
                            strokeWidth: 0.5
                        },
                        ticks: {
                            stroke: "black",
                            size: 3
                        },
                        tickLabels: {
                            fontSize: Constants.DATA_LABEL_FONT_SIZE,
                            padding: 2,
                            angle: -90,
                            verticalAnchor: "middle",
                            textAnchor: "end"
                        },
                        axisLabel: {
                            fontSize: Constants.AXIS_LABEL_FONT_SIZE,
                            padding: 65
                        }
                    }} />
                <VictoryAxis dependentAxis
                    label="Rank"
                    invertAxis={true}
                    style={{
                        grid: {
                            stroke: "grey",
                            strokeWidth: 0.5
                        },
                        ticks: {
                            stroke: "black",
                            size: 3
                        },
                        tickLabels: {
                            fontSize: Constants.DATA_LABEL_FONT_SIZE
                        },
                        axisLabel: {
                            fontSize: Constants.AXIS_LABEL_FONT_SIZE,
                            padding: 40
                        }
                    }}
                />
                <VictoryGroup
                    colorScale="qualitative"
                    categories={{ x: xTickValues }}>
                    {charts}
                </VictoryGroup>
            </VictoryChart>
            <VictoryLegend
                x={64}
                containerComponent={
                    <VictoryContainer
                        width={Constants.CHART_WIDTH}
                        height={30 + legendData.length * 30}
                    />}
                title="Manufacturer"
                symbolSpacer={11}
                colorScale="qualitative"
                data={legendData}
                style={{
                    labels: { fontSize: Constants.DATA_LABEL_FONT_SIZE },
                    title: { fontSize: Constants.AXIS_LABEL_FONT_SIZE }
                }} />
        </div >

    );
}